<template>
	<right-panel :datas="connects" ref="rightPanel" @onClose="onClose" :hideFooter="true">
		<div slot="header" class="project-header">
			<span v-if="connects" class="limit-text"><translate>Connect</translate>{{ ` ( ${connects.resourceName} )` }}</span>
		</div>
		<div slot="content" class="loading" v-if="loading">
			<img src="../../../assets/loading.gif" />
		</div>
		<div slot="content" class="project-connect" v-if="m && m.os === 'linux'">
			<div class="b-b"><translate>Verify Security</translate></div>
			<div class="vertify-content">
				<el-row v-if="m.selectUserData">
					<el-col :span="8" class="text-right"><translate>The Way Of Verification</translate><span>:</span></el-col>
					<el-col :span="13" v-if="m.selectUserData.auth_type === 0"><translate>Host Password</translate></el-col>
					<el-col :span="13" v-if="m.selectUserData.auth_type === 1">SSH KEY</el-col>
					<el-col :span="13" v-if="m.selectUserData.auth_type === 2"><translate>CloudLinker team account password</translate></el-col>
				</el-row>
				<el-row v-else>
					<el-col :span="8" class="text-right"><translate>The Way Of Verification</translate><span>:</span></el-col>
					<el-col :span="13" v-if="m.resource.csos_check === 'open'"><translate>CloudLinker team account password</translate></el-col>
					<el-col :span="13" v-if="m.resource.csos_check === 'close' && m.resource.autologin === 1">SSH KEY</el-col>
					<el-col :span="13" v-if="m.resource.csos_check === 'close' && m.resource.autologin === 0"><translate>Host Password</translate></el-col>
				</el-row>

				<el-row v-if="m.safe.network_safe_mode">
					<el-col :span="8" class="text-right"><translate>Security mode</translate><span>:</span></el-col>
					<el-col :span="4" v-show="!m.safe.safe_mode_approver && safeMode"><translate>Block</translate></el-col>
					<el-col :span="4" v-show="!m.safe.safe_mode_approver && !safeMode"><translate>Green Light</translate></el-col>
					<el-col :span="2" v-show="m.safe.safe_mode_approver && safeMode && (m.safe.safe_mode_application == 3 || m.safe.safe_mode_application == 4)"><translate>Block</translate></el-col>
					<el-col :span="6" v-show="m.safe.safe_mode_approver && safeMode && m.safe.safe_mode_application == 0"><translate>block/pending audit</translate></el-col>
					<el-col :span="6" v-show="m.safe.safe_mode_approver && safeMode && m.safe.safe_mode_application == 1"><translate>block/passed</translate></el-col>
					<el-col :span="6" v-show="m.safe.safe_mode_approver && safeMode && m.safe.safe_mode_application == 2"><translate>block/not passed</translate></el-col>
					<el-col :span="6" v-show="m.safe.safe_mode_approver && !safeMode && m.safe.safe_mode_application == 1"><translate>green light/passed</translate></el-col>
					<el-button :span="6" class="apply-safe" v-show="m.safe.safe_mode_approver && safeMode && (m.safe.safe_mode_application == 3 || m.safe.safe_mode_application == 4)" @click="startApply"><translate>Apply Non-security mode</translate></el-button>
					<el-button :span="3" v-show="!m.safe.safe_mode_approver || (m.safe.safe_mode_approver && m.safe.safe_mode_application == 1)" @click="switchSafeMode"><translate>Switch</translate></el-button>
					<el-button :span="3" class="apply-safe" v-show="m.safe.safe_mode_approver && safeMode && m.safe.safe_mode_application == 2" @click="startApply"><translate>Reapply</translate></el-button>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Default Username</translate><span>:</span></el-col>
					<el-col :span="6">
						<el-select v-model="defaultUser" @change="changeUser()">
							<el-option v-for="option in m.usernameList" :key="option.id" :label="option" :value="option"></el-option>
						</el-select>
					</el-col>
				</el-row>
			</div>
			<div class="b-b b-t"><translate>Connection Information</translate></div>
			<div class="vertify-content">
				<!-- <translate tag="h4" class="text-center" v-if="agentUpdateTip">The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible</translate> -->
				<p class="text-center" v-if="agentUpdateTip">
					<i class="el-icon-warning" style="color: #fda541; font-size: 14px; top: 2px"></i>
					<translate style="color: #fda541">The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible</translate>
				</p>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Host</translate><span>:</span></el-col>
					<el-col :span="13">{{ m.agent.host }}</el-col>
					<el-col :span="3" v-clipboard:copy="m.agent.host" v-clipboard:success="copySuccess"
						><a><translate>Copy</translate></a></el-col
					>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Port</translate><span>:</span></el-col>
					<el-col :span="13">{{ m.agent.ssh_port }}</el-col>
					<el-col :span="3" v-clipboard:copy="String(m.agent.ssh_port)" v-clipboard:success="copySuccess"
						><a><translate>Copy</translate></a></el-col
					>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Username</translate><span>:</span></el-col>
					<el-col :span="13">{{ userName }}</el-col>
					<el-col :span="3" v-clipboard:copy="userName" v-clipboard:success="copySuccess"
						><a><translate>Copy</translate></a></el-col
					>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>IP Whitelist</translate><span>:</span></el-col>
					<el-col class="ip-whitelist" :span="13">
						<div v-for="(ip, ipIndex) in getAllowIPList(m.allow_ip)" :key="ipIndex">{{ ip }}</div>
						<span v-if="!m.allow_ip">-</span>
					</el-col>
					<el-col :span="3">
						<a @click="modifyCode"><translate>Change</translate></a>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>SSH Command</translate><span>:</span></el-col>
					<el-col :span="13"
						><a :href="ssh_link">{{ codeStr }}</a></el-col
					>
					<el-col :span="3" v-clipboard:copy="codeStr" v-clipboard:success="copySuccess"
						><a><translate>Copy</translate></a></el-col
					>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Connect Username</translate><span>:</span></el-col>
					<el-col :span="12"><el-input class="linux-username" v-model="defaultUser" disabled></el-input></el-col>
					<el-col :span="3"
						><el-button :class="{ safeConnect: !safeMode }" @click.stop="connectHost"><translate>Connect</translate></el-button></el-col
					>
				</el-row>
			</div>
		</div>
		<div slot="content" class="project-connect" v-if="m && m.os === 'win32' && connects.agentVersion >= '2.4.0'">
			<div class="b-b"><translate>Verify Security</translate></div>
			<div class="vertify-content">
				<el-row>
					<el-col :span="8" class="text-right"><translate>The Way Of Verification</translate><span>:</span></el-col>
					<el-col :span="13"><translate>Login to the host using the local password</translate></el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Default Username</translate><span>:</span></el-col>
					<el-col :span="6">
						<el-select v-model="defaultUser" @change="changeUser()">
							<el-option v-for="option in m.usernameList" :key="option.id" :label="option" :value="option"></el-option>
						</el-select>
					</el-col>
				</el-row>
			</div>
			<div class="b-b b-t"><translate>Connection Information</translate></div>
			<div class="vertify-content">
				<p class="text-center" v-if="agentUpdateTip">
					<i class="el-icon-warning" style="color: #fda541; font-size: 14px; top: 2px"></i>
					<translate style="color: #fda541">The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible</translate>
				</p>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Host</translate><span>:</span></el-col>
					<el-col class="p-l-15" :span="12">{{ m.winHost }}</el-col>
					<el-col :span="3" v-clipboard:copy="m.winHost" v-clipboard:success="copySuccess"
						><a><translate>Copy</translate></a></el-col
					>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Port</translate><span>:</span></el-col>
					<el-col class="p-l-15" :span="12">{{ m.agent.rdp_port }}</el-col>
					<el-col :span="3" v-clipboard:copy="String(m.agent.rdp_port)" v-clipboard:success="copySuccess"
						><a><translate>Copy</translate></a></el-col
					>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Username</translate><span>:</span></el-col>
					<el-col class="p-l-15" :span="12">{{ userName }}</el-col>
					<el-col :span="3" v-clipboard:copy="userName" v-clipboard:success="copySuccess"
						><a><translate>Copy</translate></a></el-col
					>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>IP Whitelist</translate><span>:</span></el-col>
					<el-col class="p-l-15 ip-whitelist" :span="12">
						<div v-for="(ip, ipIndex) in getAllowIPList(m.allow_ip)" :key="ipIndex">{{ ip }}</div>
						<span v-if="!m.allow_ip">-</span>
					</el-col>
					<el-col :span="3">
						<a @click="modifyCode"><translate>Change</translate></a>
					</el-col>
				</el-row>
				<!-- 已webrdp_port是否有值作为agent是否有web-rdp的判断依据 -->
				<el-row v-if="m.agent.webrdp_port">
					<el-col :span="8" class="text-right"><translate>Connect Username</translate><span>:</span></el-col>
					<el-col :span="12"><el-input class="linux-username" v-model="defaultUser" disabled></el-input></el-col>
					<el-col :span="3"
						><el-button :class="{ safeConnect: !safeMode }" @click.stop="connectWinHost"><translate>Connect</translate></el-button></el-col
					>
				</el-row>
			</div>
			<translate tag="h4" class="text-center"></translate>
		</div>
		<div slot="content" class="project-connect" v-if="m && m.os === 'win32' && connects.agentVersion < '2.4.0'">
			<div class="b-b"><translate>Connection Information</translate></div>
			<div class="vertify-content">
				<p class="text-center" v-if="agentUpdateTip">
					<i class="el-icon-warning" style="color: #fda541; font-size: 14px; top: 2px"></i>
					<translate style="color: #fda541">The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible</translate>
				</p>
				<h3 class="l-h-36 text-center"><translate>Use the RDP client to connect to the current host</translate></h3>
				<div class="text-center l-h-36">
					<span><translate>Please confirm</translate></span>
					<a href="https://files.cloudcare.cn/rdpclient.exe"><translate>download</translate></a>
					<span><translate>and installed the RDP client (Windows only support)</translate></span>
				</div>
				<div class="text-center l-h-36"><translate>Fill in the client with Code and connect to your Windows server.</translate></div>
				<div class="l-h-36 text-center">
					<span>Code</span>
					<span>:</span>
					<span>{{ m.code }}</span>
				</div>
				<el-row>
					<el-col :span="8" class="text-right"><translate>IP Whitelist</translate><span>:</span></el-col>
					<el-col class="p-l-15 ip-whitelist" :span="12">
						<div v-for="(ip, ipIndex) in getAllowIPList(m.allow_ip)" :key="ipIndex">{{ ip }}</div>
						<span v-if="!m.allow_ip">-</span>
					</el-col>
					<el-col :span="3">
						<a @click="modifyCode"><translate>Change</translate></a>
					</el-col>
				</el-row>
				<img class="win-image" src="/static/images/screen_windows.png" alt="demo" />
			</div>
			<translate tag="h4" class="text-center"></translate>
		</div>
		<div slot="content" class="project-connect" v-if="m && (m.os === 'mysql' || m.os === 'mssql' || m.os === 'postgresql' || m.os === 'oracle')">
			<div class="loading" v-if="loading">
				<img src="../../../assets/loading.gif" />
			</div>
			<div class="b-b"><translate>Connection Information</translate></div>
			<div class="vertify-content">
				<p class="text-center" v-if="agentUpdateTip">
					<i class="el-icon-warning" style="color: #fda541; font-size: 14px; top: 2px"></i>
					<translate style="color: #fda541">The cluster's agent verison is too low. Please remind the administrator to upgrade as soon as possible</translate>
				</p>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Host</translate><span>:</span></el-col>
					<el-col class="p-l-15" :span="12">{{ m.sqlHost }}</el-col>
					<el-col :span="3" v-clipboard:copy="m.sqlHost" v-clipboard:success="copySuccess"
						><a><translate>Copy</translate></a></el-col
					>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Port</translate><span>:</span></el-col>
					<el-col class="p-l-15" :span="12">{{ m.sqlport }}</el-col>
					<el-col :span="3" v-clipboard:copy="m.sqlport" v-clipboard:success="copySuccess">
						<a><translate>Copy</translate></a>
					</el-col>
				</el-row>
				<el-row v-if="m.os === 'oracle'">
					<el-col :span="8" class="text-right"><translate>Connection identifier type</translate><span>:</span></el-col>
					<el-col class="p-l-15" :span="12">{{ m.serviceNameType === 'sid' ? 'SID' : 'Service Name' }}</el-col>
				</el-row>
				<el-row v-if="m.os === 'oracle'">
					<el-col :span="8" class="text-right"><translate>Service Name / SID</translate><span>:</span></el-col>
					<el-col class="p-l-15" :span="12">{{ m.serviceName }}</el-col>
					<el-col :span="3" v-clipboard:copy="m.serviceName" v-clipboard:success="copySuccess">
						<a><translate>Copy</translate></a>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Username</translate><span>:</span></el-col>
					<el-col class="p-l-15" :span="12">{{ m.code }}</el-col>
					<el-col :span="3" v-clipboard:copy="m.code" v-clipboard:success="copySuccess">
						<a><translate>Copy</translate></a>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>IP Whitelist</translate><span>:</span></el-col>
					<el-col class="p-l-15 ip-whitelist" :span="12">
						<div v-for="(ip, ipIndex) in getAllowIPList(m.allow_ip)" :key="ipIndex">{{ ip }}</div>
						<span v-if="!m.allow_ip">-</span>
					</el-col>
					<el-col :span="3">
						<a @click="modifyCode"><translate>Change</translate></a>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8" class="text-right"><translate>Note:</translate> </el-col>
					<el-col :span="12" class="p-l-15">
						<translate v-if="m.os === 'mysql'">Use MySQL client to connect to the current database</translate>
						<translate v-if="m.os === 'mssql'">Use SQL Server client to connect to the current database</translate>
						<translate v-if="m.os === 'postgresql'">Use PostgreSQL client to connect to the current database</translate>
						<translate v-if="m.os === 'oracle'">Oracle only supports web connections</translate>
					</el-col>
					<el-col :span="3">
						<a @click="sqlConnect"><translate>Connect</translate></a>
					</el-col>
				</el-row>
			</div>
		</div>
	</right-panel>
</template>
<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
import Base64 from 'js-base64'
import Utility from '../../../Utils'

export default {
	name: 'WorkGroupConnection',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
			m: null,
			defaultUser: '',
			userName: '',
			codeStr: '',
			ssh_link: '',
			connectData: {},
			safeMode: null,
			safeConnect: 'safe_connect',
			unSafeConnect: 'unSafe_connect',
			loading: true,
			agentUpdateTip: false,
		}
	},
	computed: {},
	mounted() {},
	created() {},
	methods: {
		getAllowIPList(allowIP) {
			if (!allowIP) {
				return []
			}
			const legacyIPv4ListPattern = /^(\d{1,3}\.){3}\d{1,3}(:(\d{1,3}\.){3}\d{1,3})+$/
			let result = []
			allowIP.split(';').forEach((section) => {
				section = section.trim()
				if (legacyIPv4ListPattern.test(section)) {
					result = result.concat(section.split(':'))
				} else if (section) {
					result.push(section)
				}
			})
			return result
		},
		modifyCode() {
			this.$emit('onShowModal', { name: 'modifyCreateModal', code: this.m.code })
		},
		// 与 code 管理面板保持相同的刷新接口，修改成功后重新加载连接信息
		getTunelInfo(id) {
			this.getConnectLog(id)
		},
		getNewAgentVersion(projectResourceId) {
			// 不只是linux
			this.$store.dispatch(STORE_CONST.CLUSTER.CHECK_AGENT).then(
				(res) => {
					this.newAgentVersion = res.version
					this.loading = false
					console.log('--version--', this.m, this.m.agent.version, '--newAgentVersion--', this.newAgentVersion)
					if (this.m && this.m.agent && this.m.agent.version && res.version) {
						if (Utility.Utils.isNeedUpdate(this.m.agent.version, res.version)) {
							this.agentUpdateTip = true
						} else {
							this.agentUpdateTip = false
						}
					}
				},
				() => {
					this.loading = false
				},
			)
		},
		onClose() {
			// console.log(this.connects.projectResourceId)
			this.$emit('onClosePanel')
			// this.$emit('reloadTunnelCode', [this.connects.projectResourceId])
			this.$emit('reloadPojectResource')
			this.connects = null
		},
		// copy text success
		copySuccess(e) {
			console.log('e', e)
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success',
			})
		},
		startApply() {
			this.$emit('startApplyEvent', this.connects.row)
		},
		switchSafeMode() {
			console.log('change safeMode', this.safeMode)
			let obj = {}
			if (this.safeMode) {
				obj = {
					code: this.m.code,
					safe_mode: 0,
				}
			} else {
				obj = {
					code: this.m.code,
					safe_mode: 1,
				}
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.UPDATE_TUNNEL, obj).then((res) => {
				this.safeMode = res.safe_mode
				this.$set(this.m, 'safe_mode', res.safe_mode)
			})
		},
		changeUser() {
			if (this.m.os == 'linux') {
				this.m.selectUserData = this.m.usernameDataList.find((i) => i.username == this.defaultUser)
			}
			this.userName = this.m.code + '_' + this.defaultUser
			this.codeStr = 'ssh' + ' ' + this.connectData.code + '_' + this.defaultUser + '@' + this.connectData.host + ' -p ' + this.connectData.sshPort
			if (window.navigator.userAgent.indexOf('Macintosh') > -1) {
				this.ssh_link = 'ssh://' + this.connectData.code + '_' + this.defaultUser + '@' + this.connectData.host + ':' + this.connectData.sshPort
			} else {
				this.ssh_link = 'ssh2://' + this.connectData.code + '_' + this.defaultUser + '@' + this.connectData.host + ':' + this.connectData.sshPort
			}
		},
		getConnectLog(id) {
			const params = {
				project_resource_id: id,
			}
			if (this.$store.getters.team.setting.code_ip_whitelist === false || this.$store.getters.team.setting.code_ip_whitelist === 0) {
				this.loadConnectInfo(params)
				return
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_CLIENT_IP).then(
				(data) => {
					params.allow_ip = data.client_ip
					this.loadConnectInfo(params)
				},
				() => {
					this.loading = false
				},
			)
		},
		loadConnectInfo(params) {
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_TUNNEL_INFO, params).then(
				(res) => {
					this.m = Object.clone(res)
					this.loading = false
					this.getNewAgentVersion() // 获取最新的agent版本
					this.connectData = {
						code: res.code,
						host: res.agent.host,
						version: Utility.Utils.getAgentVersion(res.agent.version),
						sshPort: res.agent.ssh_port,
					}
					this.safeMode = res.safe_mode
					this.m.winHost = res.agent.host
					let extension = res.project_resource.extension ? JSON.parse(res.project_resource.extension) : { login_username: '' }
					let resourceExtension = res.resource.extension ? JSON.parse(res.resource.extension) : {}
					if (res.os === 'linux') {
						this.connectData.path = '/wetty/ssh'
						this.connectData.webPort = res.agent.web_port
						if (extension && extension.login_username) {
							this.m.usernameList = extension.login_username
						} else {
							this.m.usernameList = []
						}
						if (extension && extension.data) {
							this.m.usernameDataList = extension.data
							this.m.selectUserData = this.m.usernameDataList.find((i) => i.username == this.m.usernameList[0])
						} else {
							this.m.usernameDataList = []
						}
					} else if (res.os === 'win32') {
						this.connectData.webrdp_port = res.agent.webrdp_port
						this.connectData.allow_copy_paste = res.project_resource.extension ? JSON.parse(res.resource.extension).allow_copy_paste : false
						if (extension && extension.login_username) {
							this.m.usernameList = extension.login_username
						} else {
							this.m.usernameList = []
						}
					} else if (res.os === 'mysql') {
						this.m.sqlHost = this.connectData.host
						this.m.sqlport = res.agent.mysql_port
					} else if (res.os === 'mssql') {
						this.m.sqlHost = this.connectData.host
						this.m.sqlport = res.agent.mssql_port
					} else if (res.os === 'postgresql') {
						this.m.sqlHost = this.connectData.host
						this.m.sqlport = res.agent.postgresql_port
					} else if (res.os === 'oracle') {
						this.m.sqlHost = this.connectData.host
						this.m.sqlport = res.agent.oracle_port || 9521
						this.m.serviceNameType = resourceExtension.service_name_type || 'service_name'
						this.m.serviceName = resourceExtension.service_name || ''
					}
					if (res.os === 'win32' || res.os === 'linux') {
						if (res.project_resource.default_username) {
							this.defaultUser = this.connectData.username = res.project_resource.default_username
						} else {
							this.defaultUser = this.connectData.username = this.m.usernameList[0]
						}
						if (window.navigator.userAgent.indexOf('Macintosh') > -1) {
							this.ssh_link = 'ssh://' + this.connectData.code + '_' + this.connectData.username + '@' + this.connectData.host + ':' + this.connectData.sshPort
						} else {
							this.ssh_link = 'ssh2://' + this.connectData.code + '_' + this.connectData.username + '@' + this.connectData.host + ':' + this.connectData.sshPort
						}
						this.userName = this.m.code + '_' + this.defaultUser
						this.codeStr = 'ssh' + ' ' + this.connectData.code + '_' + this.defaultUser + '@' + this.connectData.host + ' -p ' + this.connectData.sshPort
					}
				},
				() => {
					this.loading = false
				},
			)
		},
		// 连接 linux host
		connectHost() {
			console.log('this.connectData', this.connectData)
			console.log(this.$store.getters.team, 'this.$store.getters.team')
			console.log(this.$store.getters.account, 'this.$store.getters.team')

			let _link = 'http://' + this.connectData.host + ':' + this.connectData.webPort + this.connectData.path + '/' + Base64.Base64.encode(this.connectData.code) + '/' + this.defaultUser
			let agentVersionFirst = parseInt(this.connectData.version.split('.')[0])
			console.log(agentVersionFirst, 'agentVersionFirst')

			// 2.0.0 版本起改为Query Params
			if (!isNaN(agentVersionFirst) && agentVersionFirst > 1) {
				// _link = 'http://' + this.connectData.host + ':' + this.connectData.webPort + '/?code=' + Base64.Base64.encode(this.connectData.code) + '&user=' + this.defaultUser
				if (Utility.Utils.getAgentVersion(this.connectData.version) <= '3.1.25') {
					_link = `http://${this.connectData.host}:${this.connectData.webPort}/?code=${Base64.Base64.encode(this.connectData.code)}&user=${this.defaultUser}&team_name=${this.$store.getters.team.setting.full_name}&account_name=${this.$store.getters.account.name}`
				} else {
					_link = `http://${this.connectData.host}:${this.connectData.webPort}/?user=${this.defaultUser}&conn_security=${this.m.conn_security}`
				}
			}
			console.log(_link)
			window.open(_link)
		},
		// 连接windows host
		connectWinHost() {
			console.log(' this.connectData windows', this.connectData)
			const version = this.connectData.version
			let _link = ''
			if (Utility.Utils.getAgentVersion(version) <= '3.1.25') {
				// let _link = 'http://' + this.connectData.host + ':' + this.connectData.webrdp_port + '/?code=' + Base64.Base64.encode(this.connectData.code) + '&user=' + this.defaultUser + '&ip=' + this.connects.row.ip + '&resourceName=' + this.connects.resourceName + '&resourceId=' + this.connects.row.id + '&redirect_url=' + window.location.href.split('#')[0]
				_link = `http://${this.connectData.host}:${this.connectData.webrdp_port}/?allowCopyPaste=${this.connectData.allow_copy_paste}&code=${Base64.Base64.encode(this.connectData.code)}&user=${this.defaultUser}&team_name=${this.$store.getters.team.setting.full_name}&account_name=${this.$store.getters.account.name}&ip=${this.connects.row.ip}&resourceName=${this.connects.resourceName}&resourceId=${this.connects.row.id}&redirect_url=${window.location.href.split('#')[0]}`
			} else {
				_link = `http://${this.connectData.host}:${this.connectData.webrdp_port}/?user=${this.defaultUser}&redirect_url=${window.location.href.split('#')[0]}&conn_security=${this.m.conn_security}`
			}
			console.log('_win link', _link)
			window.open(_link)
		},
		sqlConnect() {
			console.log(location, 'location')
			console.log(this.m, 'm')
			console.log(this.connects, 'connects')
			console.log('数据库连接')

			window.open(`${location.origin}/webSQL/?conn_security=${this.m.conn_security}`, '_blank')
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
						this.getConnectLog(this.connects.projectResourceId)
					}, 300)
				} else {
					this.connects = this.items
					this.getConnectLog(this.connects.projectResourceId)
				}
				console.log('connects', this.connects)
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>
<style lang="scss" rel="stylesheet/scss">
@import '../../../assets/css/variable';
.project-header {
	.limit-text {
		display: inline-block;
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}
.loading {
	width: 100%;
	height: 500px;
	position: relative;
	img {
		display: block;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-left: -34px;
		margin-top: -34px;
	}
}
.project-connect {
	font-size: 12px;
	.linux-username {
		.el-input__inner {
			font-size: 12px;
			width: 220px;
		}
	}
	.el-button {
		font-size: 12px;
	}
	a {
		color: $mainColor;
		&:hover {
			text-decoration: underline;
		}
	}
	.safeConnect {
		color: $danger-color;
		border-color: $danger-color;
	}
	.apply-safe {
		display: inline-block;
		color: $mainColor;
		border: 1px solid $mainColor;
		padding: 0 10px;
		height: 32px;
		line-height: 32px;
		&:hover {
			text-decoration: none;
		}
	}
	.b-b {
		line-height: 36px;
		padding-left: 10px;
		border-bottom: 1px solid $border-color;
	}
	.p-l-15 {
		padding-left: 15px;
	}
	.ip-whitelist {
		line-height: 22px;
		padding-top: 5px;
		padding-bottom: 5px;
		word-break: break-all;
	}
	.l-h-36 {
		line-height: 36px;
	}
	.b-t {
		border-top: 1px solid $border-color;
	}
	.vertify-content {
		padding: 15px;
	}
	.el-row {
		padding-top: 10px;
		line-height: 32px;
	}
	.text-right {
		padding-right: 10px;
	}
	.win-image {
		display: block;
		margin: 0 auto;
	}
}
</style>



// WEBPACK FOOTER //
// workgroup-connection.vue?35deb52a